<template>
  <div>
    <b-card no-body class="mb-0">
      <b-form @submit.prevent="handleAddRow($event)" ref="myForm">
        <validation-observer ref="simpleRules">
          <div
            v-if="isSideDataLoading"
            style="height: 400px"
            class="d-flex justify-content-center align-items-center"
          >
            <b-spinner label="Loading..."></b-spinner>
          </div>
          <div class="m-2" v-else>
            <b-row class="d-flex justify-content-between w-100">
              <b-col md="12" class="font-weight-bolder">
                <h3 class="font-weight-bolder" style="font-size: 18px">
                  Page Content
                </h3>
              </b-col>
              <b-col md="12">
                <b-form-group>
                  <label for="input"
                    >Title<span class="font-weight-bold text-danger"
                      >*</span
                    ></label
                  >
                  <validation-provider
                    #default="{ errors }"
                    rules="required"
                    name="Title"
                  >
                    <b-form-input
                      v-model="title"
                      placeholder="Title"
                      maxlength="50"
                    ></b-form-input>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group>
                  <label for="input">Type<span class="font-weight-bold text-danger">*</span></label>
                  <validation-provider
                    #default="{ errors }"
                    rules="required"
                    name="Type"
                  >
                    <v-select
                      v-model="type"
                      placeholder="Select Type"
                      label="name"
                      :options="typeOptions"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="12">
                <b-form-group>
                  <label for="input"
                    >Page Link<span class="text-danger font-weight-bold">*</span></label
                  >
                  <validation-provider
                    #default="{ errors }"
                    rules="required"
                    name="Page Link"
                  >
                    <b-form-input
                      v-model="pagelink"
                      placeholder="Page Link"
                      maxlength="50"
                    ></b-form-input>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="12">
                <b-form-group>
                  <label for="content"
                    >Add Content<span class="text-danger font-weight-bold"
                      >*</span
                    ></label
                  >
                  <validation-provider
                    #default="{ errors }"
                    rules="required"
                    name="Add Content"
                  >
                    <quill-editor
                      ref="editor"
                      v-model="content"
                      :options="snowOption"
                      class="cms-quill-editor"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="12" style="margin-top: 73px">
                <h3 class="font-weight-bolder" style="font-size: 18px">
                  SEO Field
                </h3>
              </b-col>
              <b-col md="12">
                <b-form-group>
                  <label for="input" class="font-weight-bold">Title</label>
                  <validation-provider
                    #default="{ errors }"
                    rules="required"
                    name="Title"
                  >
                    <b-form-input
                      v-model="seoTitle"
                      placeholder="Title"
                      maxlength="50"
                    ></b-form-input>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="12">
                <b-form-group>
                  <label for="input" class="font-weight-bold"
                    >Meta Description</label
                  >
                  <validation-provider
                    #default="{ errors }"
                    rules="required"
                    name="Meta Description"
                  >
                    <b-form-input
                      v-model="metaDesc"
                      placeholder="Description"
                      maxlength="150"
                    ></b-form-input>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="12">
                <b-form-group>
                  <label for="input" class="font-weight-bold">Keywords</label>
                  <validation-provider
                    #default="{ errors }"
                    rules="required"
                    name="Keywords"
                  >
                    <b-form-input
                      v-model="keyword"
                      placeholder="Keywords"
                      maxlength="100"
                    ></b-form-input>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="12">
                <b-form-group class="cms-meta-file-group">
                  <label for="input" class="font-weight-bold">Meta Image</label>
                    <b-form-file
                      id="file-default"
                      @input="uploadDoc($event)"
                      v-model="image"
                      placeholder="Choose a file or drop it here..."
                      drop-placeholder="Drop file here..."
                      browse-text="Browse"
                    />
                </b-form-group>
              </b-col>
              <b-col md="12" class="d-flex justify-content-start mt-2">
                <b-button
                  variant="primary"
                  class="mr-1"
                  @click="handleAddRow()"
                  :disabled="flag"
                >
                  {{ ifEdit == true ? "Update" : "Save" }}
                </b-button>
                <b-button type="reset" variant="primary" @click="Close">
                  Cancel
                </b-button>
              </b-col>
            </b-row>
          </div>
        </validation-observer>
      </b-form>
    </b-card>
  </div>
</template>
  <script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BCard,
  BFormFile,
  BButton,
  BForm,
  BSpinner,
  BFormTextarea
} from "bootstrap-vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { adminPanelApi } from '@/services/adminPanelApi'
import { unwrapAdminResponse } from '@/utils/adminApiHelpers'
import { notifyError, notifySuccess } from '@/utils/uiActions'
import { quillEditor } from "vue-quill-editor";
import vSelect from 'vue-select'
import { required } from "@validations";




export default {
  components: {
    BCard,
    BSpinner,
    BFormFile,
    ValidationProvider,
    ValidationObserver,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BButton,
    BForm,
    quillEditor,
    BFormTextarea,
    vSelect
  },
  data() {
    return {
      required,
      snowOption: {
        theme: "snow",
      },
      accessToken: localStorage.getItem("accessToken"),
      title: "",
      pagelink: "",
      isSideDataLoading: false,
      content: "",
      seoTitle: "",
      keyword: "",
      image: "",
      imageFile: null,
      metaDesc: "",
      flag: false,
      ifEdit: false,
      id:null,
      type:'',
      typeOptions:[
        {name:'Terms & Conditions',value:'terms-conditions'}
      ]
    };
  },
  mounted() {
    // this.$nextTick(() => {
    //   this.$refs.editor.quill.root.style.height = '100%';
    // });
    this.ifEdit = !!this.$route.params.id;
    this.ifEdit && this.getEditValue();
  },
  methods: {
    async getEditValue() {
      this.isSideDataLoading = true
      try {
        const res = await adminPanelApi.page(this.$route.params.id)
        const item = unwrapAdminResponse(res)
        this.getEditItems(item)
      } catch (error) {
        console.error(error)
      } finally {
        this.isSideDataLoading = false
      }
    },
    getEditItems(item) {
      this.title = item.title
      this.pagelink = item.link
      this.content = item.content
      this.seoTitle = item.meta_title || item.metatitle || ''
      this.metaDesc = item.meta_description || item.metadescription || ''
      this.keyword = item.keywords || item.keyword || ''
      this.image = item.meta_image || item.metaimage || ''
      const arr = this.typeOptions.filter(inner => inner.value === item.type)
      this.type = arr.length > 0 ? arr[0] : ''
    },
    convertToSlug(Text) {
      return Text.toLowerCase()
        .replace(/ /g, "-")
        .replace(/[^\w-]+/g, "");
    },
    handleAddRow() {
      this.$refs.simpleRules.validate().then(async success => {
        if (!success) {
          notifyError(this, 'Please fill in all fields', 'Warning')
          return
        }

        const formData = new FormData()
        if (this.ifEdit) {
          formData.append('id', String(this.$route.params.id))
        }
        formData.append('title', this.title)
        formData.append('link', this.pagelink)
        formData.append('content', this.content)
        formData.append('meta_title', this.seoTitle)
        formData.append('meta_description', this.metaDesc)
        formData.append('keywords', this.keyword)
        if (this.imageFile) {
          formData.append('meta_image', this.imageFile)
        }

        try {
          await adminPanelApi.savePage(formData, true)
          notifySuccess(
            this,
            this.ifEdit ? 'CMS page updated successfully.' : 'CMS page created successfully.',
            this.ifEdit ? 'Updated' : 'Created',
          )
          this.$router.push('/cms')
        } catch (error) {
          notifyError(this, error?.response?.data?.message || 'Unable to save CMS page')
        }
      })
    },

    async uploadDoc(file) {
      if (!file) return
      this.imageFile = file
      this.flag = false
    },
    Close() {
      this.$router.push({ path: "/cms" });
      // this.Addsupple = false;
      this.openModel = false;
    },
    
  },
};
</script>
  <style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/quill.scss";

.cms-quill-editor {
  min-height: 220px;
}
</style>
  